var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import FormRow from '../../../../components/Form/Row';
import TextInput from '../../../../components/Fields/TextInput';
import { Fields } from '../../../../utils/Fields';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '../../../../components/Button';
import { Lock } from 'react-feather';
import Drawer from '../../../../components/Drawer';
import Heading from '../../../../components/Typography/Heading';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import { toast } from 'react-toastify';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
import { useOutletContext } from 'react-router-dom';
var DashboardLoginsPassword = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), drawer = _b[0], setDrawer = _b[1];
    var handleFormError = useOutletContext().handleFormError;
    var _c = useValidation(), textRequired = _c.textRequired, passwordRequired = _c.passwordRequired, passwordConfirmation = _c.passwordConfirmation;
    var placeholders = usePlaceholder();
    var schema = yup.object().shape({
        old_password: textRequired,
        new_password: passwordRequired,
        new_password_confirmation: passwordConfirmation('new_password'),
    });
    var _d = useForm({
        resolver: yupResolver(schema),
    }), handleSubmit = _d.handleSubmit, control = _d.control, setError = _d.setError;
    var handlePasswordUpdate = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axiosInstance.post(api.user.passwordUpdate, data)];
                case 2:
                    response = _a.sent();
                    toast.success('Votre mot de passe a bien été modifié');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.response.status === 422) {
                        error_1.response.data.errors.forEach(function (error) {
                            setError(Object.keys(error)[0], { message: Object.values(error)[0] });
                        });
                    }
                    else {
                        handleFormError(error_1);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (<>
      <Button type="inline" icon={Lock} side="start" className="text-brand-02 sm:self-start" onClick={function () {
            setDrawer(true);
        }}>
        Modifier mon mot de passe
      </Button>

      <Drawer handleClose={function () { return setDrawer(false); }} open={drawer}>
        <form onSubmit={handleSubmit(handlePasswordUpdate)}>
          <div className="px-drawer">
            <div className="flex flex-col gap-6">
              <Heading level={2} type="h5" className="mb-2">
                Modifier mon mot de passe
              </Heading>
              <FormRow>
                <TextInput label="Votre ancien mot de passe" type={Fields.PASSWORD} name="old_password" placeholder={placeholders.password} control={control} required/>
              </FormRow>
              <FormRow>
                <TextInput label="Votre nouveau mot de passe" type={Fields.PASSWORD} name="new_password" placeholder={placeholders.password} control={control} required/>
              </FormRow>
              <FormRow>
                <TextInput label="Confirmation de votre nouveau mot de passe" type={Fields.PASSWORD} name="new_password_confirmation" placeholder={placeholders.password} control={control} required/>
              </FormRow>
              <Button submit loading={loading} className="sm:self-start">
                Modifier mon mot de passe
              </Button>
            </div>
          </div>
        </form>
      </Drawer>
    </>);
};
export default DashboardLoginsPassword;
